var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";
import { IconMappingModule } from "../iconCorrespondance";
import { faSquare } from "@fortawesome/pro-regular-svg-icons";
export default function Placeholder(_a) {
    var _b;
    var menuItem = _a.menuItem;
    var t = useTranslation(["common"]).t;
    var _c = useState(null), openedMenu = _c[0], setOpenedMenu = _c[1];
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    var _d = useState(null), hoveredItem = _d[0], setHoveredItem = _d[1];
    return (_jsx("div", __assign({ className: "h-full px-2 py-4 overflow-auto" }, { children: _jsx("div", __assign({ className: "space-y-2" }, { children: (_b = Object.keys(menuItem)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return (_jsxs("div", __assign({ className: "menu-contain mx-2 ".concat(openedMenu === item ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex uppercase text-justify p-2 relative\n               hover:bg-[#eef1f7] hover:rounded\n              ", onMouseEnter: function () { return setHoveredItem(item); }, onMouseLeave: function () { return setHoveredItem(null); }, onClick: function () { return toggleMenu(item); } }, { children: [_jsx("span", __assign({ className: "pr-4" }, { children: t("app.".concat(item), {
                                    ns: "common",
                                }) })), _jsx("span", __assign({ className: "absolute cursor-pointer right-0 pr-2 text-[var(--colors-label)]" }, { children: (openedMenu === item || hoveredItem === item) && (_jsx(FontAwesomeIcon, { icon: openedMenu === item ? faChevronUp : faChevronDown })) }))] })), _jsx("ul", __assign({ className: openedMenu === item
                            ? "menu-contain__list block"
                            : "menu-contain__list hidden" }, { children: Object.values(menuItem[item]).map(function (i) {
                            return Object.values(i).map(function (m) {
                                var _a;
                                return (_jsx("li", __assign({ className: "hover:bg-[#eef1f7] hover:rounded px-2 py-1 text-md" }, { children: _jsxs("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(m.modules.module), title: m.modules.module }, { children: [_jsx(FontAwesomeIcon, { icon: IconMappingModule["".concat(m.modules.module)]
                                                    ? IconMappingModule["".concat(m.modules.module)]
                                                    : faSquare, className: "mr-2 text-sm" }), _jsx("span", { children: t((_a = m.modules.mod_strings) === null || _a === void 0 ? void 0 : _a.LBL_MODULE_NAME) })] })) }), m));
                            });
                        }) }))] }))); }) })) })));
}
